var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "packDetail" },
    [
      _c("p", { staticClass: "link-txt", on: { click: _vm.handleClick } }, [
        _vm._v(_vm._s(_vm.rowData[_vm.fieldData.fieldCode])),
      ]),
      _vm._v(" "),
      _c(
        "OPZDialog",
        {
          attrs: {
            title: _vm.dialog.title,
            width: _vm.dialog.width,
            visible: _vm.dialog.visible,
            "is-footer": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _vm._v(
                  "仓库：" +
                    _vm._s(_vm._f("emptyFilter")(_vm.dialog.data.warehouseName))
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 8 } }, [
                _vm._v(
                  "收货人：" +
                    _vm._s(_vm._f("emptyFilter")(_vm.dialog.data.receiveName))
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 8 } }, [
                _vm._v(
                  "收货电话：" +
                    _vm._s(_vm._f("emptyFilter")(_vm.dialog.data.receivePhone))
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("OPZTable", {
            attrs: {
              height: "300",
              columns: _vm.dialog.columns,
              "table-data": _vm.dialog.data.items || [],
              seq: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }